import { Actions } from '../../interfaces'
import { Gender } from '@/entities/persons'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { Gender },
  actions: { [Gender.name]: actions },
}
